/**
 * Smooth-scroll wrapper using Lenis (https://github.com/darkroomengineering/lenis).
 *
 * Why Lenis: the homepage scroll-reveal feels much more luxurious when paired
 * with momentum-smoothed scroll. Same pattern rhodeskin.com uses.
 *
 * Safe by design:
 *   - Bails on `prefers-reduced-motion: reduce` (no class added, native scroll).
 *   - Bails if Lenis lib failed to load — native scroll is the fallback.
 *   - PAUSES Lenis whenever a native <dialog> is open. The quick-add modal,
 *     size-conversion-modal, underwear-size-chart-modal, quiz-popup, search
 *     modal, and cart drawer all use `<dialog>`, so this prevents Lenis from
 *     fighting their internal scroll behavior or breaking their backdrop.
 *   - Only affects WINDOW scroll. Inner scroll containers (carousels, Yotpo
 *     widgets, dialog content) keep native scroll behavior.
 *
 * Lenis must be loaded before this script (see layout/theme.liquid).
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof Lenis === 'undefined') return;

  var lenis;
  try {
    lenis = new Lenis({
      duration: 1.2,
      // expo-out: fast start, long gentle tail — matches the scroll-reveal feel
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      // Leave touch alone — momentum-smoothing on mobile fights iOS native
      // inertia and feels worse than native. Industry default.
      smoothTouch: false,
      touchMultiplier: 2,
    });
  } catch (e) {
    return;
  }

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // ----- Dialog-aware pause/resume --------------------------------------
  // Native <dialog> opens via .showModal() and adds the [open] attribute.
  // MutationObserver on the [open] attribute (subtree-wide) catches every
  // dialog open/close without us having to know which dialogs exist.
  function syncDialogState() {
    if (document.querySelector('dialog[open]')) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }

  var dialogObserver = new MutationObserver(syncDialogState);
  dialogObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  });
  // Catch any dialog already open at script-init time
  syncDialogState();

  // Expose for debugging and for other scripts that want to scrollTo programmatically
  window.__lenis = lenis;
})();
